var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGolfFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "golf-filled_svg__svg-safari-fix",
  viewBox: "0 0 16.62 16.62",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BFBFFF",
  d: "M8.308 15.783a7.475 7.475 0 1 0 0-14.95 7.475 7.475 0 0 0 0 14.95"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2AC4",
  d: "M8.308 16.617C3.725 16.617 0 12.892 0 8.308S3.725 0 8.308 0s8.309 3.725 8.309 8.308-3.725 8.309-8.309 8.309m0-14.95a6.65 6.65 0 0 0-6.641 6.641 6.643 6.643 0 0 0 6.641 6.642 6.643 6.643 0 0 0 6.642-6.642 6.643 6.643 0 0 0-6.642-6.641"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2AC4",
  d: "M10.392 10.816a.733.733 0 1 0 0-1.466.733.733 0 0 0 0 1.466M12.767 8.417a.733.733 0 1 0 0-1.467.733.733 0 0 0 0 1.467M12.733 10.917a.733.733 0 1 0 0-1.467.733.733 0 0 0 0 1.467M11.017 13.191a.733.733 0 1 0 0-1.466.733.733 0 0 0 0 1.466M8.608 13.833a.733.733 0 1 0 0-1.466.733.733 0 0 0 0 1.466"
})));
export default SvgGolfFilled;